module.exports = {
	"version": "1.2350.6",
	"manifest": {
		"a11yTestKit": "1.2350.4",
		"adminLoginButton": "1.2326.5",
		"animations": "1.2326.5",
		"audioCommon": "1.2311.5",
		"audioPlayer": "1.2224.7",
		"backToTopButton": "1.2224.7",
		"backgroundCommon": "1.2350.4",
		"balata": "1.2350.4",
		"bgImageStrip": "1.2224.7",
		"boxSlideShowSlide": "1.2224.7",
		"buttonCommon": "1.2326.5",
		"checkbox": "1.2311.5",
		"clipArt": "1.2224.7",
		"column": "1.2224.7",
		"comboBoxInput": "1.2311.5",
		"compDesignUtils": "1.2293.8",
		"compUtils": "1.2326.5",
		"components": "1.2350.4",
		"componentsPreviewLayer": "1.2335.5",
		"contactForm": "1.2350.4",
		"container": "1.2224.7",
		"containerCommon": "1.2271.8",
		"core": "1.2350.6",
		"coreUtils": "1.2350.4",
		"dataFixer": "1.2350.4",
		"datePicker": "1.2326.5",
		"dateUtils": "1.2224.7",
		"deadComponent": "1.2224.7",
		"displayer": "1.2350.4",
		"disqusComments": "1.2293.15",
		"documentMedia": "1.2350.4",
		"documentServices": "1.2350.5",
		"documentServicesSchemas": "1.2350.4",
		"dropDownMenu": "1.2350.4",
		"editingRendererPlugins": "1.2224.7",
		"exitMobileModeButton": "1.2224.7",
		"facebookComments": "1.2224.7",
		"facebookLike": "1.2350.4",
		"facebookLikeBox": "1.2326.5",
		"facebookShare": "1.2224.7",
		"fileUploader": "1.2293.11",
		"flashComponent": "1.2326.5",
		"flickrBadgeWidget": "1.2224.7",
		"fonts": "1.2326.5",
		"fontsPrefetch": "1.2224.7",
		"footerContainer": "1.2350.4",
		"formCommon": "1.2335.3",
		"galleriesCommon": "1.2335.3",
		"googleMap": "1.2350.4",
		"groupContainer": "1.2224.7",
		"headerContainer": "1.2350.4",
		"hoverBox": "1.2224.7",
		"htmlComponent": "1.2326.5",
		"image": "1.2350.4",
		"imageButton": "1.2326.5",
		"imageClientApi": "1.2224.7",
		"imageCommon": "1.2311.5",
		"imageZoom": "1.2326.5",
		"imageZoomDisplayer": "1.2350.4",
		"infoTip": "1.2326.5",
		"internalMarkings": "1.2326.5",
		"itunesButton": "1.2335.3",
		"layout": "1.2350.4",
		"linkBar": "1.2350.4",
		"loggingUtils": "1.2326.5",
		"loginButton": "1.2293.8",
		"loginSocialBar": "1.2350.4",
		"matrixGallery": "1.2335.3",
		"mediaCommon": "1.2350.4",
		"mediaContainerFactory": "1.2293.8",
		"mediaControls": "1.2350.4",
		"mediaPlayer": "1.2350.4",
		"mediaZoom": "1.2335.3",
		"memoizeAPI": "1.2350.4",
		"menuButton": "1.2350.4",
		"messageView": "1.2224.7",
		"mobileActionsMenu": "1.2271.8",
		"multilingual": "1.2335.3",
		"page": "1.2254.5",
		"pageGroup": "1.2335.3",
		"paginatedGridGallery": "1.2326.5",
		"paypalButton": "1.2335.3",
		"pinItPinWidget": "1.2326.5",
		"pinterestFollow": "1.2224.7",
		"pinterestPinIt": "1.2350.4",
		"popupCloseTextButton": "1.2350.4",
		"popupContainer": "1.2350.4",
		"previewExtensionsCore": "1.2224.7",
		"qaAutomation": "1.2335.3",
		"quickActionBar": "1.2293.8",
		"quickActionBarItem": "1.2224.7",
		"radioButton": "1.2326.5",
		"radioGroup": "1.2311.5",
		"render": "1.2335.3",
		"rssButton": "1.2326.5",
		"santaPreview": "1.2326.5",
		"santaProps": "1.2350.4",
		"screenWidthContainer": "1.2224.7",
		"server": "1.2326.5",
		"singleAudioPlayer": "1.2311.5",
		"siteBackground": "1.2350.4",
		"siteButton": "1.2350.4",
		"siteUtils": "1.2350.4",
		"skinExports": "1.2350.4",
		"skins": "1.2350.4",
		"skypeCallButton": "1.2224.7",
		"slideShowGallery": "1.2326.5",
		"sliderGallery": "1.2311.5",
		"socialCommon": "1.2350.4",
		"soundCloudWidget": "1.2350.4",
		"spotifyFollow": "1.2326.5",
		"spotifyPlayer": "1.2350.4",
		"stripColumnsContainer": "1.2350.4",
		"stripContainer": "1.2224.7",
		"stripSlideShow": "1.2350.4",
		"stripSlideShowSlide": "1.2224.7",
		"subscribeForm": "1.2326.5",
		"svgCommon": "1.2350.4",
		"svgShape": "1.2350.4",
		"testUtils": "1.2350.4",
		"textArea": "1.2326.5",
		"textCommon": "1.2335.6",
		"textInput": "1.2293.8",
		"tinyMenu": "1.2350.4",
		"tpa": "1.2335.3",
		"tpaGalleries": "1.2335.6",
		"translationsUtils": "1.2350.4",
		"tweenEngine": "1.2224.7",
		"twitterFeed": "1.2224.7",
		"utils": "1.2350.4",
		"vKShareButton": "1.2350.4",
		"verticalAnchorsMenu": "1.2350.4",
		"verticalMenu": "1.2350.4",
		"video": "1.2350.4",
		"wGooglePlusOne": "1.2335.3",
		"wPhoto": "1.2326.5",
		"wRichText": "1.2224.7",
		"wTwitterFollow": "1.2350.4",
		"wTwitterTweet": "1.2350.4",
		"warmup": "1.2326.9",
		"widgets": "1.2350.4",
		"wixCode": "1.2335.5",
		"wixCodeInit": "1.2326.5",
		"wixCodeSeo": "1.2326.5",
		"wixSites": "1.2335.3",
		"wixSkinOnly": "1.2224.7",
		"wixUrlParser": "1.2335.3",
		"wixappsBuilder": "1.2326.5",
		"wixappsClassics": "1.2350.6",
		"wixappsCore": "1.2350.6",
		"youTubeSubscribeButton": "1.2326.5",
		"zoomedImage": "1.2224.7"
	},
	"versions": {
		"mobx": "3.1.0",
		"mobxReact": "3.5.8",
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"a11yTestKit",
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"bgImageStrip",
		"boxSlideShowSlide",
		"buttonCommon",
		"checkbox",
		"clipArt",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"displayer",
		"disqusComments",
		"documentMedia",
		"documentServices",
		"documentServicesSchemas",
		"dropDownMenu",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"facebookShare",
		"fileUploader",
		"flashComponent",
		"flickrBadgeWidget",
		"fonts",
		"fontsPrefetch",
		"footerContainer",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"groupContainer",
		"headerContainer",
		"hoverBox",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"imageZoom",
		"imageZoomDisplayer",
		"infoTip",
		"internalMarkings",
		"itunesButton",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"loginSocialBar",
		"matrixGallery",
		"mediaCommon",
		"mediaContainerFactory",
		"mediaControls",
		"mediaPlayer",
		"mediaZoom",
		"memoizeAPI",
		"menuButton",
		"messageView",
		"mobileActionsMenu",
		"multilingual",
		"page",
		"pageGroup",
		"paginatedGridGallery",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"quickActionBar",
		"quickActionBarItem",
		"radioButton",
		"radioGroup",
		"render",
		"rssButton",
		"santaPreview",
		"santaProps",
		"screenWidthContainer",
		"server",
		"singleAudioPlayer",
		"siteBackground",
		"siteButton",
		"siteUtils",
		"skinExports",
		"skins",
		"skypeCallButton",
		"slideShowGallery",
		"sliderGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShow",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgCommon",
		"svgShape",
		"testUtils",
		"textArea",
		"textCommon",
		"textInput",
		"tinyMenu",
		"tpa",
		"tpaGalleries",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"vKShareButton",
		"verticalAnchorsMenu",
		"verticalMenu",
		"video",
		"wGooglePlusOne",
		"wPhoto",
		"wRichText",
		"wTwitterFollow",
		"wTwitterTweet",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixSkinOnly",
		"wixUrlParser",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"youTubeSubscribeButton",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 26
// module chunks = 0